import AirportLocationModal from '@/components/MedicalAirport/AirportLocationModal';
import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { GUIDE_STEP } from '@/constant/airport.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { AIRPORT_LIST } from '@repo/constants';
import { Button } from '@successmode-ktp/kui';
import { useState } from 'react';
import styled from 'styled-components';

const MedicalAirportGuide = () => {
  const [isOpenLocationModal, setIsOpenLocationModal] = useState(false);
  const { nationality, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const selectedAirport =
    passportNumber && localStorage.getItem(passportNumber);
  const selectedAirportValue = AIRPORT_LIST.find(
    (i) => i.value === selectedAirport,
  );
  const airportLabel = selectedAirportValue
    ? selectedAirportValue[nationality === 'KOR' ? 'korLabel' : 'label']
    : '';

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    title: ['How to get a refund?', '환급절차 안내'],
    viewLocationButton: ['View Customs Location', '세관 위치 보기'],
  };

  return (
    <>
      <ReceiptLayout hasPadding={false}>
        <Title>{text.title[nationIndex]}</Title>
        <GuideList>
          {GUIDE_STEP(airportLabel).map(
            ({ id, title, korTitle, description, korDescription, image }) => (
              <GuideItem key={id}>
                <GuideTitle>
                  {nationality === 'KOR' ? korTitle : title}
                </GuideTitle>
                <GuideDescription>
                  {nationality === 'KOR' ? korDescription : description}
                </GuideDescription>
                <GuideImage src={image} alt='' />
                {id === 1 && (
                  <Button
                    onClick={() => setIsOpenLocationModal(true)}
                    size='lg'
                    style={{
                      marginTop: '12px',
                      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                    }}
                  >
                    {text.viewLocationButton[nationIndex]}
                  </Button>
                )}
              </GuideItem>
            ),
          )}
        </GuideList>
      </ReceiptLayout>
      <AirportLocationModal
        isOpen={isOpenLocationModal}
        onClose={() => setIsOpenLocationModal(false)}
        selectedAirport={selectedAirport}
      />
    </>
  );
};

const Title = styled.h2`
  width: 100%;
  padding: 12px 20px 20px 20px;
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  box-shadow: 0px 4px 4px 0px rgba(216, 216, 216, 0.25);
  background-color: #fff;
`;

const GuideList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
  padding: 20px;
  margin-bottom: 48px;
`;

const GuideItem = styled.li``;

const GuideTitle = styled.h3`
  display: inline-block;
  width: auto;
  padding: 4px 12px;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  background-color: #666;
  margin-bottom: 12px;
`;

const GuideDescription = styled.p`
  color: #333;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 12px;
`;

const GuideImage = styled.img`
  width: 100%;
`;

export default MedicalAirportGuide;
